import { render, staticRenderFns } from "./AddSerialNumber.vue?vue&type=template&id=b6a9951c&scoped=true"
import script from "./AddSerialNumber.vue?vue&type=script&lang=js"
export * from "./AddSerialNumber.vue?vue&type=script&lang=js"
import style0 from "./AddSerialNumber.vue?vue&type=style&index=0&id=b6a9951c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9951c",
  null
  
)

export default component.exports